const e = Object.freeze({
  normal: {
    value: "normal",
    className: ""
  },
  small: {
    value: "small",
    className: "_small"
  },
  extraSmall: {
    value: "extra-small",
    className: "_extra-small"
  },
  large: {
    value: "large",
    className: "_large"
  }
}), a = Object.freeze({
  desktop: {
    value: "desktop",
    className: "_d"
  },
  mobile: {
    value: "mobile",
    className: ""
  }
}), l = Object.freeze({
  default: {
    value: "default",
    className: ""
  },
  secondary: {
    value: "secondary",
    className: "_secondary"
  },
  more: {
    value: "more",
    className: "_more"
  },
  link: {
    value: "link",
    className: "_link"
  },
  linkDashed: {
    value: "link-dashed",
    className: "_link-dashed"
  }
});
export {
  l as TYPES_BUTTON,
  a as TYPE_PLATFORM,
  e as TYPE_SIZES
};
